const concatUrl = (endpoint)=>{
    if ("u" < typeof window || process.env.API_FULL_PATH) {
        const apiUrl = process.env.API_URL || '';
        return `${apiUrl}${endpoint}`;
    }
    const runTimeApiUrl = window.CREH_APOLLO_API_URL;
    if (runTimeApiUrl) return `${runTimeApiUrl}${endpoint}`;
    return endpoint;
};
const BASE_PATH = '/api/v2/graph';
const GRAPH_ENDPOINT = concatUrl('/api/v2/graph/');
const GRAPH_ENDPOINT_AUTH = concatUrl(`${BASE_PATH}/auth/`);
const GRAPH_ENDPOINT_PAYMENTS = concatUrl(`${BASE_PATH}/payments/`);
const GRAPH_ENDPOINT_PRIVATE = concatUrl(`${BASE_PATH}/private/`);
const GRAPH_ENDPOINT_B2B = concatUrl(`${BASE_PATH}/b2b/`);
const GRAPH_ENDPOINT_SEARCH = concatUrl(`${BASE_PATH}/search/`);
const GRAPH_ENDPOINT_V3 = concatUrl('/api/v3/graph/');
const GRAPH_ENDPOINT_V4 = concatUrl('/api/graph/');
const GRAPH_ENDPOINT_V4_AUTHENTICATION = concatUrl('/api/graph/authentication/');
const GRAPH_ENDPOINT_V4_B2B = concatUrl('/api/graph/b2b/');
const GRAPH_ENDPOINT_V4_STAFF = concatUrl('/api/graph/staff/');
const GRAPH_ENDPOINT_V5 = concatUrl('/api/v5/graph/');
const GRAPH_ENDPOINT_SUBSCRIPTIONS = concatUrl('/api/graph/analytics/');
const GRAPH_ENDPOINT_V5_ANALYTICS = concatUrl('/api/v5/graph/analytics');
const GRAPH_ENDPOINT_CENTRALIZED = concatUrl('/api/graph/centralized/');
const GRAPH_ENDPOINT_TALENT_FEEDBACK = concatUrl('/api/graph/talent/feedback/');
export { GRAPH_ENDPOINT, GRAPH_ENDPOINT_AUTH, GRAPH_ENDPOINT_B2B, GRAPH_ENDPOINT_CENTRALIZED, GRAPH_ENDPOINT_PAYMENTS, GRAPH_ENDPOINT_PRIVATE, GRAPH_ENDPOINT_SEARCH, GRAPH_ENDPOINT_SUBSCRIPTIONS, GRAPH_ENDPOINT_TALENT_FEEDBACK, GRAPH_ENDPOINT_V3, GRAPH_ENDPOINT_V4, GRAPH_ENDPOINT_V4_AUTHENTICATION, GRAPH_ENDPOINT_V4_B2B, GRAPH_ENDPOINT_V4_STAFF, GRAPH_ENDPOINT_V5, GRAPH_ENDPOINT_V5_ANALYTICS };
